export const shopVendorsList = [
    {   id: 'chicken_republic', 
        logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTM4KYGgPbn3ZSppE-1YL5baXENgT36Mq0fijlKrGaIKF21Inc4800uBQylpUt_3npc7xU&usqp=CAU', 
        name: 'Chicken Republic', 
        location: 'Okha',
    
    },
    {   id: 'coldstone', 
        logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQBBOHJZMDMHtzPvQzGuOj-YL0bUWTSNi1B3g&usqp=CAU', 
        name: 'ColdStone', 
        location: 'Ugbor',
        
    },
    {    id: 'market_square', 
        logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTFHo0LUQ1HXo0YBe4WglJrSvGyYZZbvC_1dw&usqp=CAU', 
        name: 'Market Square', 
        location: 'Okha',
        
    },
    {       id: 'dominos_pizza', 
        logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcROeTza6KUhUnzmhUKut-YRUHEW05A2Rowtdg&usqp=CAU', 
        name: 'Dominos Pizza', 
        location: 'Okha',
        
    },
    {       id: 'genesis', 
        logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQV6PU1Zn74eavlQWx5nAE1DnxqXTJ7WoiXPA&usqp=CAU', 
        name: 'Genesis', 
        location: 'Ugbor',
        
    },
    {    id: 'kilimanjaro', 
        logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSSnDwanKJC0I8la9lPMA6GfuKEmKZBnJZHmQ&usqp=CAU', 
        name: 'Kilimanjaro', 
        location: 'Okha',
        
    },
    {    id: 'pizza_hut', 
        logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTvF2SdltrfU9K9Zsp9duUhnqE43mEO317u8w&usqp=CAU', 
        name: 'Pizza Hut', 
        location: 'Ugbor',
        
    },
    {       id: 'food_hub', 
        logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR9xZ1MrFakcIflKNe_IQ0pun_z5WCZQl6p-Q&usqp=CAU', 
        name: 'Food Hub', 
        location: 'Ugbor',
        
    },
    {    id: 'pizza_moore', 
        logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSp_xEWjjacZYrBjKkD2Zr4nyH1uXsQ855nuA&usqp=CAU', 
        name: 'PizzaMoore', 
        location: 'Okha',
        
    }
]